import { render, staticRenderFns } from "./CustomerInfoPartial.vue?vue&type=template&id=1b736c3c&scoped=true&"
import script from "./CustomerInfoPartial.vue?vue&type=script&lang=js&"
export * from "./CustomerInfoPartial.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInfoPartial.vue?vue&type=style&index=0&id=1b736c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b736c3c",
  null
  
)

export default component.exports